"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-like-feedback.tsx
var LikeFeedback = function LikeFeedback(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_1555_7597)"
  }, (0, _preact.h)("path", {
    d: "M1.3335 13.3333H2.66683C3.0335 13.3333 3.3335 13.0333 3.3335 12.6666V6.66659C3.3335 6.29992 3.0335 5.99992 2.66683 5.99992H1.3335V13.3333ZM14.5535 8.58659C14.6268 8.41992 14.6668 8.23992 14.6668 8.05325V7.33325C14.6668 6.59992 14.0668 5.99992 13.3335 5.99992H9.66683L10.2802 2.89992C10.3135 2.75325 10.2935 2.59325 10.2268 2.45992C10.0735 2.15992 9.88016 1.88659 9.64016 1.64659L9.3335 1.33325L5.06016 5.60659C4.80683 5.85992 4.66683 6.19992 4.66683 6.55325V11.7799C4.66683 12.6333 5.36683 13.3333 6.22683 13.3333H11.6335C12.1002 13.3333 12.5402 13.0866 12.7802 12.6866L14.5535 8.58659Z",
    fill: "currentColor"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_1555_7597"
  }, (0, _preact.h)("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
};

var _default = LikeFeedback;
exports.default = _default;